import React from 'react';
import styled from 'styled-components';
import { colors } from '../../../../../../../constants/colors';
import { fontSize, fontFamily } from '../../../../../../../constants/text';

const Root = styled.div.withConfig({ componentId: 'sc-d628b2-0' })`
  background-color: ${colors.theWhiteAlbum};
  padding: 25px 30px;
  border-bottom: 1px solid ${colors.granite};
  box-shadow: inset 0 1px 0 0 ${colors.emptyBarGrey}, inset 0 -1px 0 0 ${colors.emptyBarGrey};
`;

const Disclaimer = styled.div.withConfig({ componentId: 'sc-d628b2-1' })`
  color: ${colors.lightText};
  font-family: ${fontFamily.book};
  font-size: ${fontSize.small};
  letter-spacing: 0.25px;
  line-height: 20px;
  padding-bottom: 10px;
`;

const Footnote = () => (
  <Root>
    <Disclaimer>
      Solv provides this information to help you better understand and manage your expected costs.
      However, this information is an estimate and may not reflect your final visit costs. Contact
      your insurer for the most accurate benefits and price information.
    </Disclaimer>
  </Root>
);

export default Footnote;
